import ReactNativeFile from "@repo/graphql/client/file";
import * as ImagePicker from "expo-image-picker";
import { useCallback, useState } from "react";

type Props = {
  onSelection?: (newFile: ReactNativeFile) => void;
  options?: Omit<
    ImagePicker.ImagePickerOptions,
    "preferredAssetRepresentationMode"
  >;
};

export const createFile = (newUri: ImagePicker.ImagePickerAsset) => {
  return new ReactNativeFile({
    uri: newUri.uri,
    name: newUri.fileName || "image.jpg",
    type: newUri.mimeType ?? "image/jpeg",
    fileSize: newUri.fileSize,
  });
};

const useImagePicker = ({ options }: Props = {}) => {
  const [uri, setUri] = useState<ImagePicker.ImagePickerAsset[] | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const launch = useCallback(async () => {
    const timeout = setTimeout(() => setLoading(true), 500);
    try {
      const result = await ImagePicker.launchImageLibraryAsync({
        ...options,
        preferredAssetRepresentationMode:
          ImagePicker.UIImagePickerPreferredAssetRepresentationMode.Current,
      });
      if (result.canceled) return null;
      setUri(result.assets);
      return result.assets;
    } finally {
      clearTimeout(timeout);
      setLoading(false);
    }
  }, [options]);
  const file: ReactNativeFile[] | null = uri?.map(createFile) || null;
  return {
    file,
    onPress: launch,
    setUri,
    imageAsset: uri,
    loading,
  };
};

export default useImagePicker;
